import Game from "../games/Game";

export default function Games() {
  return (
    <div className="games-page">
      <Game />
    </div>
  );
}